/* @generated */

// src/assets/ui-icon/fill/person.tsx
import * as React from "react";
var PersonFill = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M14.75 11.875h-.613c.646-.61.988-1.58.988-2.875 0-2.338-1.11-3.625-3.125-3.625-2.015 0-3.125 1.287-3.125 3.625 0 1.294.341 2.265.988 2.875H9.25a3.88 3.88 0 0 0-3.875 3.875v2.875h13.25V15.75a3.88 3.88 0 0 0-3.875-3.875Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  PersonFill
};
